"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatepickerControl = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
require("react-text-mask");
const datepicker_styles_1 = require("./datepicker.styles");
const datepicker_types_1 = require("./datepicker.types");
const Calendar = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/calendar'))));
const defaultMask = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
exports.DatepickerControl = (0, react_1.memo)((0, react_1.forwardRef)((_a, ref) => {
    var _b, _c;
    var { value, placeholder, isValueSelected, showInput, error, label, time, datePickerRef, sizeType } = _a, props = __rest(_a, ["value", "placeholder", "isValueSelected", "showInput", "error", "label", "time", "datePickerRef", "sizeType"]);
    const theme = (0, theme_1.useTheme)();
    const maskedInputRef = (0, react_1.useRef)(null);
    const isCalendarOpen = (_b = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _b === void 0 ? void 0 : _b.isCalendarOpen();
    const maskedInputElement = (_c = maskedInputRef === null || maskedInputRef === void 0 ? void 0 : maskedInputRef.current) === null || _c === void 0 ? void 0 : _c.inputElement;
    const [hideLabel, setHideLabel] = (0, react_1.useState)(false);
    const labelText = (0, react_1.useMemo)(() => hideLabel || (sizeType === datepicker_types_1.SizeType.MEDIUM && value) ? '' : label, [sizeType, value, hideLabel, label]);
    (0, react_1.useEffect)(() => {
        if (maskedInputElement && showInput) {
            if (isCalendarOpen) {
                maskedInputElement.focus();
                if (sizeType === datepicker_types_1.SizeType.MEDIUM) {
                    setHideLabel(true);
                }
            }
            else {
                maskedInputElement.blur();
                if (sizeType === datepicker_types_1.SizeType.MEDIUM) {
                    setHideLabel(false);
                }
            }
        }
    }, [isCalendarOpen]);
    (0, react_1.useEffect)(() => {
        if (maskedInputElement) {
            maskedInputElement.value = maskedInputElement.value;
        }
    }, [maskedInputElement]);
    const handleKeyDown = (e) => {
        var _a;
        if (e.key === 'Enter') {
            (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.blur();
        }
    };
    const handleIconOnClick = () => {
        var _a, _b;
        (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(!isCalendarOpen);
        if (!isCalendarOpen) {
            (_b = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _b === void 0 ? void 0 : _b.setFocus();
        }
    };
    const handleOnTouchStart = () => {
        var _a;
        if (!(props === null || props === void 0 ? void 0 : props.disabled))
            (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.setFocus();
    };
    return (react_1.default.createElement(datepicker_styles_1.StyledDatepickerControl, Object.assign({ isValueSelected: isValueSelected, ref: ref, error: error }, props, { tabIndex: 0, onTouchStart: handleOnTouchStart, sizeType: sizeType }),
        time && (react_1.default.createElement(datepicker_styles_1.StyledTime, { hasValue: value, time: time, showInput: showInput, sizeType: sizeType }, String(`, ${time}`))),
        labelText && (react_1.default.createElement(datepicker_styles_1.StyledLabel, { value: value, isValueSelected: isValueSelected, error: error, sizeType: sizeType }, labelText)),
        showInput ? (react_1.default.createElement(datepicker_styles_1.StyledMaskedTextInput, { ref: maskedInputRef, label: Boolean(labelText), value: value, placeholder: placeholder, disabled: props.disabled, type: "numeric", inputMode: "numeric", mask: defaultMask, onKeyDown: handleKeyDown, sizeType: sizeType })) : ((!value && placeholder && (react_1.default.createElement(datepicker_styles_1.StyledDatepickerPlaceholder, null, placeholder))) ||
            (labelText ? (react_1.default.createElement(datepicker_styles_1.StyledValue, { disabled: props.disabled }, value)) : (value))),
        react_1.default.createElement(datepicker_styles_1.StyledCalendarIcon, { onClick: handleIconOnClick },
            react_1.default.createElement(react_1.Suspense, { fallback: null },
                react_1.default.createElement(Calendar, { width: 24, color: props.disabled
                        ? (0, theme_1.rgba)(theme.colors.icon.primary, 0.4)
                        : theme.colors.icon.primary })))));
}));
